/* eslint react/jsx-no-bind:0 */
import React from "react";
import { Switch, Route, Redirect,withRouter } from "react-router-dom"
import { processSilentRenew } from 'redux-oidc'
import Register from "./containers/userregistration"
import LandingPage from './containers/landingPage' 
// import Dashboard from "./containers/dashboard"
import IndexPage from "./components/layout/IndexPage" 
import CallbackPage from './CallbackComponent'
import OldBrowserPage from './OldBrowserPage'
import "./Vendor.js"
import "./styles/bootstrap.scss"
import "./styles/app.scss"

const App = () => (
  <Switch>
    <Route path="/signin-oidc" component={CallbackPage} />
    <Route path="/signin-silentrenew" component={()=><div>{processSilentRenew()}</div>} />
    <Route path="/signout-callback-oidc" component={()=><Redirect to="/"/>} />
    <Route path="/register" component={Register} />
    <Route path="/dashboard"  component={IndexPage} />  

    <Route exact path="/oldbrowser" component={OldBrowserPage} />

    <Route exact path="/event" component={IndexPage} />
    <Route exact path="/events/:id" component={IndexPage} /> 
    <Route exact path="/postevent" component={IndexPage} />
    <Route exact path="/viewevents" component={IndexPage} />
    <Route path="/upcomingevents" component={IndexPage} />
    <Route path="/seasonsettings" component={IndexPage} />
    <Route path="/reports" component={IndexPage} />
    <Route path="/manageadvancers" component={IndexPage} />
    <Route path="/orphanedevents" component={IndexPage} />
    <Route path="/test" component={IndexPage}/>
    <Route path="/managedeposits" component={IndexPage}/>
    <Route path="/usermanagement" component={IndexPage} /> 
    <Route exact path="/"  component={LandingPage} />  

  </Switch>
)
export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js